import { FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import React from 'react';

import { DURATION_LIST } from 'FRONTEND/utils/constants';
import i18n from 'FRONTEND/utils/i18n';

export const DurationPicker = ({
  onChange,
  defaultDuration,
  desiredDuration,
  label,
}) => {
  return (
    <FormControl
      sx={{
        width: '380px',
        maxWidth: '100%',
      }}
    >
      <InputLabel id='dateTimeStep-durationLabel'>
        {defaultDuration === desiredDuration ? (
          <Typography noWrap color='primary'>{label}</Typography>
        ) : (
          i18n._('Custom appointment duration')
        )}
      </InputLabel>
      <Select
        variant='standard'
        labelId='dateTimeStep-durationLabel'
        id='dateTimeStep-durationSelect'
        value={desiredDuration}
        onChange={(event) => onChange(event.target.value)}
      >
        {DURATION_LIST.map((duration) => (
          <MenuItem key={duration} value={duration}><Typography sx={{ color: (theme) => duration === defaultDuration ? theme.palette.primary.main : 'inherit' }}>{`${duration} ${i18n._('minutes')}`}</Typography></MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
